;(function () {
  'use strict'
  var basePageURL = "/pages/engagement-rings";
  var selectors = {
    range: '.range-item',
    summary: '.summary-c-select__btn',
    tagsForm: '.filter-form',
    filterFormLabel: '.filter-form .tag__checkbox-wrapper',
    filterFormSortBy: '.filter-form .sort-by',
    priceRange: '.price-range',
  }
  var loadUrl = {
    sapphire: '/pages/engagement-rings?view=gemstones&local=true',
    ring: '/collections/engagement-rings-australia?view=sapphire&local=true',
  }

  function navigateWithCartEdit(url) {
    if (window.KavalriCartEdit && typeof window.KavalriCartEdit.appendFlowParams === 'function') {
      window.location.href = window.KavalriCartEdit.appendFlowParams(url)
      return
    }
    window.location.href = url
  }

  const baseFilter = {
    shape: [],
    carat_from: '0.50',
    carat_to: '7.00',
    width_from: '0.50',
    width_to: '20.00',
    length_from: '0.50',
    length_to: '20.00',
    mm_depth_from: '0.50',
    mm_depth_to: '20.00',
    colour: [],
    clarity: [],
    is_curated: [],
    treatment: [],
    origin: [],
    price_from: 0,
    price_to: 20000,
  }
  window.countDownData = function ({ cutOffTime, timeZone, leadTime }) {
    return {
      cutOffTime: cutOffTime,
      timeZone: timeZone,
      leadTime: leadTime,
      deadline: getTimeRemainingUntil(cutOffTime, timeZone),
      dispatchDate: formatDateToDDOrdinalMMMYYYY(getDispatchDate(leadTime, cutOffTime, timeZone)),
      countdown() {
        setInterval(() => {
          this.deadline = getTimeRemainingUntil(this.cutOffTime, this.timeZone) // Update the deadline every second
          if (this.deadline === '00 hours 00 minutes 00 seconds') {
            this.dispatchDate = getDispatchDate(this.leadTime, this.cutOffTime, this.timeZone) // Update the dispatch date if the deadline has passed
            this.deadline = getTimeRemainingUntil(this.cutOffTime, this.timeZone)
          }
        }, 1000)
      },
    }
  }
  // DOMready(function(){})() .  observer = new IntersectionObserver(([{ isIntersecting: visible }])
  document.addEventListener('alpine:init', () => {
    Alpine.store('gemstoneStore', {
      leftDiamond:  localStorage.getItem("diamond-selected-left-item")
        ? JSON.parse(localStorage.getItem("diamond-selected-left-item"))
        : {},
      summaryType: localStorage.getItem('alpine-gemstone-summaryType') || 'grid',
      gemstoneId: localStorage.getItem('alpine-gemstone-gemstoneId') || '',
      showProgress: false,
      headerFilter: false,
      express: false,
      stepItem: {},
      loading2: false,
      step:  1,
      showOtherStep: false,
      observer: {},
      init() {
        const urlParams = new URLSearchParams(window.location.search);
        document.addEventListener('cart-edit:ready', event => {
          const context = event.detail && event.detail.context
          if (!context || (window.KavalriCartEdit && window.KavalriCartEdit.getFlowStoneType(context) !== 'sapphire')) {
            return
          }
          this.stepItem = JSON.parse(localStorage.getItem('alpine-gemstone-stepItem') || '{}')
          this.express = context.targetRole === 'child'
          this.step = 2
        })
        this.express = urlParams.get('path') === 'express'
        if (!(window.KavalriCartEdit && window.KavalriCartEdit.isActive()) && this.stepItem && this.stepItem._cartEditId) {
          localStorage.removeItem('alpine-gemstone-stepItem')
          localStorage.removeItem('alpine-gemstone-step')
          this.stepItem = {}
          this.step = 1
        }
        if(!this.express && localStorage.getItem('alpine-gemstone-stepItem') && JSON.parse(localStorage.getItem('alpine-gemstone-stepItem')).type == 'express'){
          localStorage.removeItem('alpine-gemstone-stepItem')
          localStorage.removeItem('alpine-gemstone-gemstoneId')
          localStorage.removeItem('alpine-gemstone-step')
          localStorage.removeItem('alpine-gemstone-collection-href')
          this.step = 1;
        }

        if(!urlParams.get("local") && !(window.KavalriCartEdit && window.KavalriCartEdit.isActive())){
           localStorage.removeItem("gemstone-filter")
           localStorage.removeItem('alpine-gemstone-stepItem')
           localStorage.removeItem('alpine-gemstone-gemstoneId')
           localStorage.removeItem('alpine-gemstone-step')
        }

        if(localStorage.getItem('alpine-gemstone-step')){
          this.step = localStorage.getItem('alpine-gemstone-step');
        }
        if (localStorage.getItem('alpine-gemstone-stepItem')) {
          this.stepItem = JSON.parse(localStorage.getItem('alpine-gemstone-stepItem'))
        }
        if (!(window.KavalriCartEdit && window.KavalriCartEdit.isActive()) && this.stepItem && this.stepItem._cartEditId) {
          localStorage.removeItem('alpine-gemstone-stepItem')
          localStorage.removeItem('alpine-gemstone-step')
          this.stepItem = {}
          this.step = 1
        }
        if (this.stepItem.id && this.step == 2 && !this.express) {
          this.gemstoneId = ''
          localStorage.removeItem('alpine-gemstone-gemstoneId')
          const bodyData = { uid: this.stepItem.uid }
          fetch(gemstoneUrl + '/api/gemstones/product', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'x-api-key': gemstoneApiKey,
            },
            body: JSON.stringify(bodyData),
          })
            .then(response => response.json())
            .then(responseJson => {
              this.stepItem = Object.assign(this.stepItem, responseJson)
              // this.step = step
              localStorage.setItem('alpine-gemstone-stepItem', JSON.stringify(this.stepItem))
            })
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              this.headerFilter = !entry.isIntersecting
            })
          },
          { rootMargin: '0px 0px 0px 0px' }
        )

        if (window.KavalriCartEdit && window.KavalriCartEdit.isActive()) {
          window.KavalriCartEdit.getContext().then(window.KavalriCartEdit.stageContext).then(context => {
            if (window.KavalriCartEdit.getFlowStoneType(context) !== 'sapphire') {
              return
            }
            this.stepItem = JSON.parse(localStorage.getItem('alpine-gemstone-stepItem') || '{}')
            this.express = context.targetRole === 'child'
            this.step = 2
          }).catch(error => console.error('Unable to restore sapphire cart edit', error))
        }
      },
      updateSummaryType(submmaryType) {
        this.summaryType = submmaryType
        localStorage.setItem('alpine-gemstone-summaryType', this.summaryType)
      },
      selectProduct(id, isStep) {
        if (this.stepItem && this.stepItem._cartEditLocked && String(id) === String(this.stepItem.id)) {
          return
        }
        if (!isStep) {
          this.gemstoneId = id
          localStorage.setItem('alpine-gemstone-gemstoneId', this.gemstoneId)
          localStorage.removeItem('alpine-gemstone-step')
          setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
          },300)
        }
        if (this.step != 1) {
          if (!this.express) {
            navigateWithCartEdit(loadUrl.sapphire)
          } else if (isStep) {
            navigateWithCartEdit('/collections/' + this.stepItem.collection_handle + '/products/' + this.stepItem.handle)
          }
        }
      },
      removeProduct() {
        if (this.stepItem && this.stepItem._cartEditLocked) {
          return
        }
        const collection_handle = this.stepItem.collection_handle
        this.stepItem = {}
        this.gemstoneId = ''
        localStorage.removeItem('alpine-gemstone-stepItem')
        localStorage.removeItem('alpine-gemstone-gemstoneId')
        localStorage.removeItem('alpine-gemstone-step')
        if (this.step != 1) {
          if (!this.express) {
            navigateWithCartEdit(loadUrl.sapphire)
          } else {
            navigateWithCartEdit('/collections/' + collection_handle)
          }
        }
      },
      clearGemstoneId() {
        this.gemstoneId = ''
        localStorage.removeItem('alpine-gemstone-gemstoneId')
      },
      setStepValue(step, product, hrefStr) {
        if(step == 2 && this.leftDiamond && this.leftDiamond.title){
          this.step = 21
          localStorage.setItem('alpine-gemstone-step', 21)

          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }else{
          this.step = step
          localStorage.setItem('alpine-gemstone-step', step)
        }
        this.loading2 = true
        if (this.express) {
          if (hrefStr == '#') {
            this.stepItem = product
            localStorage.setItem('alpine-gemstone-stepItem', JSON.stringify(this.stepItem))
            this.loading2 = false
          } else {
            // loading
            const bodyData = { uid: product.uid }
            fetch(gemstoneUrl + '/api/gemstones/product', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'x-api-key': gemstoneApiKey,
              },
              body: JSON.stringify(bodyData),
            })
              .then(response => response.json())
              .then(responseJson => {
                const selectedGemstoneData = Object.assign({}, product, responseJson);
                if (window.KavalriCartBundle && window.KavalriCartBundle.getProductProperties) {
                  selectedGemstoneData.productProperties = window.KavalriCartBundle.getProductProperties(selectedGemstoneData, document);
                }
                if(this.showOtherStep){
                  if(!this.leftDiamond || !this.leftDiamond.variant_id){
                    localStorage.setItem(
                      "diamond-selected-left-item",
                      JSON.stringify(selectedGemstoneData)
                    );
                    this.leftDiamond = JSON.parse(localStorage.getItem("diamond-selected-left-item"));
                    this.step = 21
                    localStorage.setItem('alpine-gemstone-step', 21)
                    this.clearGemstoneId()
                    this.loading2 = false
                    
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth"
                    });
                    return;
                  }
                }

                const ringItem = {
                  quantity: 1,
                  id: this.stepItem.variantId,
                  properties: {
                    'Ring Size': this.stepItem.ringSize,
                  },
                };
                const submitItems = [ringItem];
                const normalizeChildData = window.KavalriCartBundle && window.KavalriCartBundle.normalizeChildData;
                const addChildVariant = window.KavalriCartBundle && window.KavalriCartBundle.addChildVariant;

                if (!normalizeChildData || !addChildVariant) {
                  this.loading2 = false;
                  alert('Unable to prepare the selected gemstone. Please refresh and try again.');
                  return;
                }

                const selectedGemstoneChildData = normalizeChildData(selectedGemstoneData, 'SAPPHIRE');
                if (this.showOtherStep) {
                  selectedGemstoneChildData.optionKey = 'right';
                }
                addChildVariant(
                  submitItems,
                  ringItem,
                  selectedGemstoneData.variant_id,
                  selectedGemstoneChildData
                );

                if (window.KavalriCartEdit && window.KavalriCartEdit.isActive()) {
                  window.KavalriCartEdit.replaceChild(
                    selectedGemstoneData.variant_id,
                    normalizeChildData(selectedGemstoneData, 'SAPPHIRE')
                  ).catch(error => {
                    this.loading2 = false
                    alert(error.message)
                  })
                  return
                }

                if (this.showOtherStep && this.leftDiamond && this.leftDiamond.variant_id) {
                  const leftGemstoneData = normalizeChildData(this.leftDiamond, 'SAPPHIRE');
                  leftGemstoneData.optionKey = 'left';
                  addChildVariant(
                    submitItems,
                    ringItem,
                    this.leftDiamond.variant_id,
                    leftGemstoneData
                  );
                }

                /** InsCoder 2026-08-10 B + Keep the selected Pavé option in Sapphire express bundles. **/
                const paveSelection = window.KavalriPaveOption && window.KavalriPaveOption.getSelection
                  ? window.KavalriPaveOption.getSelection()
                  : null;
                const paveVariantId = this.stepItem && this.stepItem.childrenVariantId;

                if ((paveSelection || paveVariantId) && window.KavalriPaveOption && window.KavalriPaveOption.appendBundleItem) {
                  window.KavalriPaveOption.appendBundleItem(submitItems, ringItem, paveVariantId);
                }
                /** InsCoder 2026-08-10 E + Keep the selected Pavé option in Sapphire express bundles. **/

                setTimeout(() => {
                  $.ajax({
                    dataType: 'json',
                    url: '/cart/add.js',
                    method: 'POST',
                    data: {
                      items: submitItems
                    },
                    success: () => {

                      localStorage.removeItem("diamond-selected-left-item");
                      localStorage.removeItem('alpine-gemstone-stepItem')
                      localStorage.removeItem('alpine-gemstone-gemstoneId')
                      localStorage.removeItem('alpine-gemstone-step')
                      localStorage.removeItem('alpine-gemstone-collection-href')
                      if (window.KavalriPaveOption && window.KavalriPaveOption.clearSelection) {
                        window.KavalriPaveOption.clearSelection();
                      }
                      window.location.href = '/cart'
                    },
                    error: data => {
                      this.loading2 = false
                      // remove
                      localStorage.removeItem("diamond-selected-left-item");
                      localStorage.removeItem('alpine-gemstone-stepItem')
                      localStorage.removeItem('alpine-gemstone-gemstoneId')
                      localStorage.removeItem('alpine-gemstone-step')
                      localStorage.removeItem('alpine-gemstone-collection-href')
                      alert(data.responseJSON.description)
                    },
                  })
                },4000)
              })
          }
        } else {
          this.stepItem = product
          const bodyData = { uid: this.stepItem.uid }
          fetch(gemstoneUrl + '/api/gemstones/product', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'x-api-key': gemstoneApiKey,
            },
            body: JSON.stringify(bodyData),
          })
            .then(response => response.json())
            .then(responseJson => {
              this.stepItem = Object.assign(this.stepItem, responseJson)
              if (window.KavalriCartBundle && window.KavalriCartBundle.getProductProperties) {
                this.stepItem.productProperties = window.KavalriCartBundle.getProductProperties(this.stepItem, document);
              }
              // this.step = step
              localStorage.setItem('alpine-gemstone-stepItem', JSON.stringify(this.stepItem));

              let shape1 = this.stepItem.shape.toUpperCase()
              let shape2 = this.stepItem.shape.charAt(0).toUpperCase() + this.stepItem.shape.slice(1)
              navigateWithCartEdit(hrefStr
                ? hrefStr
                : loadUrl.ring +
                  '&filter.p.tag=' +
                  this.stepItem.shape +
                  '&filter.p.tag=' +
                  shape1 +
                  '&filter.p.tag=' +
                  shape2)
            })
         
        }
      },
    })
    // gemstones
    Alpine.data('gemstones', () => ({
      summaryOpen: false,
      diamondUrl: "",
      diamondPopup: false,
      // summarySelected: 'Relevance',
      openFilter: false,
      isCompare: false,
      page: { page: 1, max_results: 24 },
      order: { order_by: 'price', order_type: 'asc' },
      total_items: 0,
      selectedItems: [],
      data: [],
      showAdvanced: true,
      filter: {
        shape: [],
        carat_from: '0.50',
        carat_to: '7.00',
        width_from: '0.50',
        width_to: '20.00',
        length_from: '0.50',
        length_to: '20.00',
        mm_depth_from: '0.50',
        mm_depth_to: '20.00',
        colour: [],
        clarity: [],
        is_curated: [],
        treatment: [],
        origin: [],
        price_from: 0,
        price_to: 20000,
      },
      stats: {
        shape: {
          cushion: 0,
          radiant: 0,
          heart: 0,
          round: 0,
          square: 0,
          emerald: 0,
          marquise: 0,
          oval: 0,
          trilliant: 0,
          pear: 0,
        },
        colour: {
          other: 0,
          orange: 0,
          teal: 0,
          blue: 0,
          white: 0,
          yellow: 0,
          purple: 0,
          green: 0,
          pink: 0,
        },
        clarity: {
          'eye-clean': 0,
        },
      },
      sidebar: {},
      filterName: '',
      initDrawerBoolean: false,
      get tableItems() {
        return this.isCompare ? this.selectedItems : this.data
      },
      selectedFilter(filterName) {
        this.filterName = filterName
      },
      get summarySelected(){
        if(!this.order.order_by){
          return 'Relevance'
        }else if(this.order.order_by == 'price'){
          if(this.order.order_type == 'asc'){
            return 'Price:Low to High'
          }else{
            return 'Price:High to Low'
          }
        }else if(this.order.order_by == 'carat'){
          if(this.order.order_type == 'asc'){
            return 'Carat:Low to High'
          }else{
            return 'Carat:High to Low'
          }
        }
      },
      selectAll() {
        if (this.filterName) {
          const checkboxs = document
            .querySelector('.collection-sidebar button[data-drawer-name="' + this.filterName + '"]')
            .closest('.collection-sidebar__group')
            .querySelectorAll('input[type="checkbox"]:not(:checked)')
          checkboxs.forEach(function (checkbox) {
            checkbox.checked = true
            checkbox.dispatchEvent(new Event('change'))
          })
        }
      },
      changeSelected(product) {
        let array = this.selectedItems
        array.findIndex(el => el.id === product.id) !== -1
          ? array.splice(
              array.findIndex(el => el.id === product.id),
              1
            )
          : array.push(product)
        this.selectedItems = array
      },
      drawerOpen() {
        document.querySelector('html').classList.add('filter-drawer-open')
      },
      drawerClose() {
        document.querySelector('html').classList.remove('filter-drawer-open')
      },
      init() {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('sapphire-color')){
          this.filter.colour = [urlParams.get('sapphire-color')]
        }

        if (urlParams.get('sapphire-shape')){
          this.filter.shape = [urlParams.get('sapphire-shape')]
        }

        if(localStorage.getItem("gemstone-filter")){
          this.filter = JSON.parse(localStorage.getItem("gemstone-filter"))
        }


        if (urlParams.get('path') === 'express') {
          this.$store.gemstoneStore.express = true
          const express_product_handle = urlParams.get('product_handle')
          const express_collection_handle = urlParams.get('collection_handle')
          const express_selected_variant_id = urlParams.get('selected_variant_id')
          const express_ring_size = urlParams.get('ring_size')
          const express_children_variant_id = urlParams.get('children_variant_id')
          fetch(`https://kavalri.com.au/products/${express_product_handle}.json`)
            .then(response => response.json())
            .then(data => {
              // The product data is now stored in `data.product`
              let product = data.product
              const selectedVariant = product.variants.find(
                variant => variant.id.toString() === express_selected_variant_id
              )

              const selectedImage = product.images.find(image =>
                image.variant_ids.includes(parseInt(express_selected_variant_id))
              ) || product.images[0]

              product.product_title = product.title
              product.price = selectedVariant.price
              product.image_url = selectedImage ? selectedImage.src : ''
              product.variant_title = selectedVariant.title
              product.variantId = express_selected_variant_id
              product.ringSize = express_ring_size
              product.childrenVariantId = express_children_variant_id
              product.collection_handle = express_collection_handle
              product.type = "express"
              if (window.KavalriCartEdit && window.KavalriCartEdit.isActive()) {
                product._cartEditId = window.KavalriCartEdit.getEditId()
                product._cartEditLocked = true
              }

              if(localStorage.getItem("diamond-selected-left-item")){
                this.$store.gemstoneStore.leftDiamond = JSON.parse(localStorage.getItem("diamond-selected-left-item"));
                this.$store.gemstoneStore.setStepValue(21, product, '#')
              }else{
                this.$store.gemstoneStore.setStepValue(2, product, '#')
              }
              // const tags = product.tags.split(',')
              const tags = product.tags.toLowerCase()
              if(tags && tags.toLowerCase().indexOf("toietmoi")>-1){
                if(this.$store.gemstoneStore.step == 2){
                    //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                    // Filter the label to determine whether it is selected by default
                    if (tags.indexOf('left-stone-round') > -1) {
                      this.filter.shapes = ['round']
                    } else if (tags.indexOf('left-stone-oval') > -1) {
                      this.filter.shapes = ['oval']
                    } else if (tags.indexOf('left-stone-square') > -1) {
                      this.filter.shapes = ['square']
                    } else if (tags.indexOf('left-stone-cushion') > -1) {
                      this.filter.shapes = ['cushion']
                    } else if (tags.indexOf('left-stone-trilliant') > -1) {
                      this.filter.shapes = ['trilliant']
                    } else if (tags.indexOf('left-stone-emerald') > -1) {
                      this.filter.shapes = ['emerald']
                    } else if (tags.indexOf('left-stone-pear') > -1) {
                      this.filter.shapes = ['pear']
                    } else if (tags.indexOf('left-stone-radiant') > -1) {
                      this.filter.shapes = ['radiant']
                    } else if (tags.indexOf('left-stone-marquise') > -1) {
                      this.filter.shapes = ['marquise']
                    }
                  }else{
                    //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                    // Filter the label to determine whether it is selected by default
                    if (tags.indexOf('right-stone-round') > -1) {
                      this.filter.shapes = ['round']
                    } else if (tags.indexOf('right-stone-oval') > -1) {
                      this.filter.shapes = ['oval']
                    } else if (tags.indexOf('right-stone-square') > -1) {
                      this.filter.shapes = ['square']
                    } else if (tags.indexOf('right-stone-cushion') > -1) {
                      this.filter.shapes = ['cushion']
                    } else if (tags.indexOf('right-stone-trilliant') > -1) {
                      this.filter.shapes = ['trilliant']
                    } else if (tags.indexOf('right-stone-emerald') > -1) {
                      this.filter.shapes = ['emerald']
                    } else if (tags.indexOf('right-stone-pear') > -1) {
                      this.filter.shapes = ['pear']
                    } else if (tags.indexOf('right-stone-radiant') > -1) {
                      this.filter.shapes = ['radiant']
                    } else if (tags.indexOf('right-stone-marquise') > -1) {
                      this.filter.shapes = ['marquise']
                    }
                  }
              }else{
                //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                // Filter the label to determine whether it is selected by default
                if (tags.indexOf('round') > -1) {
                  this.filter.shape = ['round']
                } else if (tags.indexOf('oval') > -1) {
                  this.filter.shape = ['oval']
                } else if (tags.indexOf('square') > -1) {
                  this.filter.shape = ['square']
                } else if (tags.indexOf('cushion') > -1) {
                  this.filter.shape = ['cushion']
                } else if (tags.indexOf('trilliant') > -1) {
                  this.filter.shape = ['trilliant']
                } else if (tags.indexOf('emerald') > -1) {
                  this.filter.shape = ['emerald']
                } else if (tags.indexOf('pear') > -1) {
                  this.filter.shape = ['pear']
                } else if (tags.indexOf('radiant') > -1) {
                  this.filter.shape = ['radiant']
                } else if (tags.indexOf('marquise') > -1) {
                  this.filter.shape = ['marquise']
                }
              }
              this.getList()
            })
        } else {
          this.getList()
        }
        this.initSummary()
        this.initWatch()
        this.initRange()
        this.initFilter()
        this.initSlidebar()
        this.initDrawer()
        window.on('resize', theme.utils.debounce(500, this.initDrawer))
      },
      get filterdeTags() {
        let combinedArray = []
        for (let key in this.filter) {
          if (this.$store.gemstoneStore.express && key == 'shape') {
            continue
          }
          if (key=="is_curated" || key == "shape" || key == "colour" || key == "treatment" || key == "clarity" || key == "origin") {
            if (Array.isArray(this.filter[key]) && this.filter[key].length > 0) {
              combinedArray = combinedArray.concat(
                this.filter[key].map((item) => key + "--" + item)
              );
            }
          } else{

            if(key.indexOf("_from") > -1){
              const title = key.replace("_from","")
              const to = title + "_to"
              if(this.filter[key] != baseFilter[key] || this.filter[to] != baseFilter[to]){

                combinedArray.push(key+"--"+title+":"+this.filter[key] + "~" + this.filter[to])
              }
            }
          }
        }
        return combinedArray
      },
      clearFilterTag() {
        this.filter = {
          shape: [],
          carat_from: '0.50',
          carat_to: '7.00',
          colour: [],
          clarity: [],
          treatment: [],
          origin: [],
          price_from: 0,
          price_to: 20000,
        }
        this.initRange()
        this.initSlidebar();
      },

      removeFilterTag(tagItem) {
        let [key, value] = tagItem.split("--");
        if(!Array.isArray(this.filter[key])){
          if(key.indexOf("_from") > -1){
            const title = key.replace("_from","")
            const to = title + "_to"
            this.filter[key] = baseFilter[key]
            this.filter[to] =  baseFilter[to]
            const $filter =  $(".range-filter[data-value-1='"+key+"']");
            let times = $filter.data('times')
            $filter.slider('values', [baseFilter[key] / (times || 1), baseFilter[to] / (times || 1)]);
          }else{
            this.filter[key] = baseFilter[key]
          }
        }else{
          this.filter[key] = this.filter[key].filter((item) => item !== value);
        }
      },
      getList: function (isPush) {
        if(!isPush){
          this.page = { page: 1, max_results: 24 }
        }
        let params = JSON.parse(JSON.stringify(this.filter));
        params = Object.assign(params, this.page)
        params = Object.assign(params, this.order)
        if(params.is_curated && params.is_curated.length > 0 && params.carat_from < 0.9){
          params.carat_from = 0.9
          params.lab = 'GSI'
        }
        delete params.is_curated
        fetch(gemstoneUrl + '/api/gemstones', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-api-key': gemstoneApiKey,
          },
          body: JSON.stringify(params),
        })
          .then(response => response.json())
          .then(responseJson => {
            var res = responseJson.response
            if (res.code == 200) {
              if(isPush){
                this.data = this.data.concat(res.items)
              }else{
                this.data = res.items
              }
              this.stats = res.stats
              this.total_items = res.total_items
              this.$refs.progress.style.width = (this.data.length / this.total_items * 100).toFixed(2) + '%';
            }
            this.$nextTick(() => {
              this.$refs.gemstones.classList.remove('loading')
            })
          })
          .catch(err => reject(err))
      },
      initDrawer: function () {
        if (!this.initDrawerBoolean && window.innerWidth < 768) {
          this.$store.gemstoneStore.observer.observe(
            document.querySelector('.collection-filter__item--btn.mobile-only svg')
          )
          this.openFilter = false
          this.initDrawerBoolean = true
          let drawerBtns = document.querySelectorAll('.collection-sidebar button[data-drawer-name]')
          drawerBtns.forEach(el => {
            el.addEventListener('click', event => {
              this.filterName = el.dataset.drawerName
            })
          })
        }
      },
      clearFilter: function () {
        let drawerBtn = document.querySelector(
          '.collection-sidebar button[data-drawer-name = "' + this.filterName + '"]'
        )
        $(drawerBtn).trigger('click.collapsible')
        this.filterName = ''
      },
      initSummary: function (event) {
        const summarys = document.querySelectorAll(selectors.summary)
        summarys.forEach(el => {
          el.addEventListener('click', event => {
            summarys.forEach(item => item.classList.remove('summary-selected'))
            const selectedItem = event.target
            selectedItem.classList.add('summary-selected')
            if (selectedItem.dataset.value) {
              // this.summarySelected = selectedItem.innerText
              let order = {}
              if (selectedItem.dataset.value.includes('-')) {
                order.order_type = 'desc'
              } else {
                order.order_type = 'asc'
              }
              order.order_by = selectedItem.dataset.value.replace('-', '')
              this.order = order
            } else {
              this.order = {}
            }
          })
        })
      },
      initSlidebar: function () {
        this.sidebar = new theme.CollectionSidebar(this.$refs.gemstones);
        this.sidebar.init();

        let that = this;
        $('#diamonds-filters .range-filter').each(function(){
          var $filter = $(this),
              var1 = $filter.data('value-1'),
              var2 = $filter.data('value-2'),
              $input1 = $filter.parent().find('input[data-value-1]'),
              $input2 = $filter.parent().find('input[data-value-2]'),
              min = parseFloat($filter.data('min')),
              max = parseFloat($filter.data('max')),
              times = $filter.data('times'),
              toFixed = (times ? (times == '0.1' ? 1 : 2) : null),
              values = $filter.data('values'),
              Min0 = min * (times || 1),
              Max0 = max * (times || 1);

          if ($input1 && $input2) {
            if (times) {
              if(that.filter[var1]){
               $input1.val(that.filter[var1]);
              }else{
                $input1.val(Min0.toFixed(toFixed));
              }
              if(that.filter[var2]){
               $input2.val(that.filter[var2]);
              }else{
                $input2.val(Max0.toFixed(toFixed));
              }
            } else if (values) {

            } else {
              if(that.filter[var1]){
               $input1.val(that.filter[var1]);
              }else{
                $input1.val(min);
              }
              if(that.filter[var2]){
               $input2.val(that.filter[var2]);
              }else{
                $input2.val(max);
              }
            }
            $input1.off('change').change(function(e) {
              this.value = parseFloat(this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')).toFixed(toFixed);
              var float_value = parseFloat(this.value);
              if (isNaN(this.value) || float_value < Min0) {
                this.value = Min0.toFixed(toFixed);
              }
              if (float_value > that.filter[var2] && float_value <= Max0) {
                that.filter[var2] = float_value;
                that.filter[var1] = float_value;
                $input2.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2]] / (times || 1));
              } else
              if (float_value > that.filter[var2] && float_value > Max0) {
                this.value = Max0.toFixed(toFixed);
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input2.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else {
                that.filter[var1] = float_value;
                $filter.slider('values', 0, that.filter[var1] / (times || 1));
              }
              if (this.value > min) {
                $clear.toggleClass('visible', true);
              }
            });

            $input2.off('change').change(function(e) {
              this.value = parseFloat(this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')).toFixed(toFixed);
              var float_value = parseFloat(this.value);
              if (isNaN(this.value) || float_value > Max0) {
                this.value = Max0.toFixed(toFixed);
              }
              if (float_value < that.filter[var1] && float_value >= Min0) {
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input1.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else
              if (float_value < that.filter[var2] && float_value < Min0) {
                this.value = Min0.toFixed(toFixed);
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input1.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else {
                that.filter[var2] = float_value;
                $filter.slider('values', 1, that.filter[var2] / (times || 1));
              }
            });
          }

          const startFilter = that.filter[var1]? values&&values.length > 0? values.indexOf(that.filter[var1]):that.filter[var1]/(times?times:1):min;
          const endFilter = that.filter[var2]? values&&values.length > 0? values.indexOf(that.filter[var2]):that.filter[var2]/(times?times:1):max;
          $filter.slider({
            range: true,
            min: min,
            max: max,
            values: [startFilter, endFilter],
            stop: function( event, ui ) {
              if (times) {
                that.filter[var1] = ((ui.values[0] * (times != null ? times : 1)).toFixed(toFixed));
                that.filter[var2] = ((ui.values[1] * (times != null ? times : 1)).toFixed(toFixed));
              } else if (values) {
                that.filter[var1] = values[ui.values[0]];
                that.filter[var2] = values[ui.values[1]];
              } else {
                that.filter[var1] = ui.values[0];
                that.filter[var2] = ui.values[1];
              }
            },
            slide: function( event, ui ) {
              if ($input1 && $input2) {
                if (times) {
                  $input1.val((ui.values[0] * (times != null ? times : 1)).toFixed(toFixed));
                  $input2.val((ui.values[1] * (times != null ? times : 1)).toFixed(toFixed));
                } else
                if (values) {

                } else {
                  $input1.val(ui.values[0]);
                  $input2.val(ui.values[1]);
                }
              }
            }
          });
        });
      },
      initRange: function () {
        const rangeEls = document.querySelectorAll(selectors.range)
        rangeEls.forEach(el => {
          const sliderEl = el.querySelector('.range__slider')
          const type = el.dataset.type
          const minValue = 'int' == type ? parseInt(el.dataset.minValue) : parseFloat(el.dataset.minValue)
          const maxValue = 'int' == type ? parseInt(el.dataset.maxValue) : parseFloat(el.dataset.maxValue)
          const minName = el.dataset.minName
          const maxName = el.dataset.maxName
          const step = 'int' == type ? parseInt(el.dataset.step) : parseFloat(el.dataset.step)
          el.querySelector('.range__display-min').innerText = el.dataset.min
          el.querySelector('.range__display-max').innerText = el.dataset.max
          if (sliderEl && sliderEl.noUiSlider && typeof sliderEl.noUiSlider.destroy === 'function') {
            sliderEl.noUiSlider.destroy()
          }
          var slider = noUiSlider.create(sliderEl, {
            connect: true,
            step: step,
            ...{},
            // Do not allow overriding these options
            start: [minValue, maxValue],
            range: {
              min: minValue,
              max: maxValue,
            },
          })

          slider.on('change', values => {
            this.filter[minName] = 'int' == type ? parseInt(values[0]) : values[0]
            this.filter[maxName] = 'int' == type ? parseInt(values[1]) : values[1]
          })
        })
      },
      initWatch: function () {

         this.$watch("$store.gemstoneStore.stepItem", (value)=>{
          if(value.tags && value.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.gemstoneStore.showOtherStep = true;
          }
        });
        
        // this.$watch('page', value => {
        //   this.getList(true)
        // })
        this.$watch('order', value => {
          this.getList()
        })
        this.$watch('filter', value => {
         localStorage.setItem("gemstone-filter", JSON.stringify(value));
          this.getList()
          const rangeEls = document.querySelectorAll(selectors.range)
          rangeEls.forEach(el => {
            const sliderEl = el.querySelector('.range__slider')
            const minName = el.dataset.minName
            const maxName = el.dataset.maxName
           if (sliderEl && sliderEl.noUiSlider) {
             if(minName == "price_from" && maxName == "price_to"){
              sliderEl.noUiSlider.updateOptions({start:[value[minName],value[maxName]]})
             }
             if(minName == "carat_from" && maxName == "carat_to"){
              sliderEl.noUiSlider.updateOptions({start:[value[minName],value[maxName]]})
             }
             if(minName == "length_from" && maxName == "length_to"){
              sliderEl.noUiSlider.updateOptions({start:[value[minName],value[maxName]]})
             }
             if(minName == "width_from" && maxName == "width_to"){
              sliderEl.noUiSlider.updateOptions({start:[value[minName],value[maxName]]})
             }
             if(minName == "mm_depth_from" && maxName == "mm_depth_to"){
              sliderEl.noUiSlider.updateOptions({start:[value[minName],value[maxName]]})
             }
          }
          });
        })
      },
      initFilter: function () {},
    }))
    // gemstone
    Alpine.data('gemstone', () => ({
      cutOffTime: '17:00',
      timeZone: 'Australia/Melbourne',
      leadTime: 40,
      deadline: '',
      dispatchDate: '',
      countdown() {
        setInterval(() => {
          this.deadline = getTimeRemainingUntil(this.cutOffTime, this.timeZone) // Update the deadline every second
          if (this.deadline === '00 hours 00 minutes 00 seconds') {
            this.dispatchDate = getDispatchDate(this.leadTime, this.cutOffTime, this.timeZone) // Update the dispatch date if the deadline has passed
            this.deadline = getTimeRemainingUntil(this.cutOffTime, this.timeZone)
          }
        }, 1000)
      },
      gemstoneId: new URLSearchParams(window.location.search).get('id'),
      gemstoneItem: {},
      flickity: {},
      init() {
        fetch(basePageURL + "?view=diamond-view-ajax", {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
            Accept: "text/html",
          },
        }).then(response => response.text()).then(htmlContent => {
           const parser = new DOMParser();
           const doc = parser.parseFromString(htmlContent, "text/html");
           const target =  document.querySelector(".page-gemstone-preview .reviews");
           target.parentNode.insertBefore(doc.querySelector(".step-by-step-video--section"), target);
        }).catch(error => {
        });
        
        this.deadline = getTimeRemainingUntil(this.cutOffTime, this.timeZone)
        this.dispatchDate = formatDateToDDOrdinalMMMYYYY(getDispatchDate(this.leadTime, this.cutOffTime, this.timeZone))
        this.countdown()
        if (this.$store.gemstoneStore.gemstoneId) {
          this.gemstoneId = this.$store.gemstoneStore.gemstoneId
        }
        this.$watch('$store.gemstoneStore.gemstoneId', value => {
          this.gemstoneId = this.$store.gemstoneStore.gemstoneId
          this.getDetail()
        })
        this.getDetail()


         this.$watch("$store.gemstoneStore.stepItem", (value)=>{
          if(value.tags && value.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.gemstoneStore.showOtherStep = true;
          }
        });

        if(this.$store.gemstoneStore.stepItem){
          const selectedItem = this.$store.stepItem.stepItem
          if(selectedItem.tags && selectedItem.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.gemstoneStore.showOtherStep = true;
          }
        }
      },
      getDetail: function () {
        if (!this.gemstoneId) {
          return
        }
        fetch(gemstoneUrl + '/api/gemstones/' + this.gemstoneId, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-api-key': gemstoneApiKey,
          },
        })
          .then(response => response.json())
          .then(responseJson => {
            var res = responseJson.response
            if (res.code == 200) {
              var item = res.item
              if (item.video_url && document.body.clientWidth < 500) {
                const widthCustom = document.body.clientWidth - 34;
                item.video_url = item.video_url.replace(
                  '500/500',
                 widthCustom + '/' + widthCustom
                )
                this.$refs.gemstoneFrame.setAttribute('width', widthCustom)
                this.$refs.gemstoneFrame.setAttribute('height', widthCustom)
              }
              this.gemstoneItem = item
              this.$nextTick(() => {
                this.initPhotos()
              })
            }
          })
          .catch(err => reject(err))
      },

      initPhotos: function () {
        const gemstoneDocument = this.$refs.gemstone
        // Initialize filter
        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: 0,
          childNav: gemstoneDocument.querySelector('[data-product-thumbs]'),
          childNavScroller: gemstoneDocument.querySelector('.product__thumbs--scroller'),
          childVertical: true,
          pageDots: true,
          wrapAround: true,
          cellAlign: 'left',
          prevNextButtons: true,
          // callbacks: {
          // 	onInit: this.onSliderInit.bind(this),
          // 	onChange: this.onSlideChange.bind(this)
          // }
        }
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy()
        }

        this.flickity = new theme.Slideshow(gemstoneDocument.querySelector('[data-product-photos]'), mainSliderArgs)

        var container = gemstoneDocument.querySelector('[data-product-images]')

        var imageZoom = new theme.Photoswipe(container, 'gemstone')
        container.addEventListener(
          'photoswipe:afterChange',
          function (evt) {
            this.flickity.goToSlide(evt.detail.index)
          }.bind(this)
        )
      },
    }))
    // ring
    Alpine.data('ring', () => ({
      summaryOpen: false,
      openFilter: true,
      filterName: '',
      flickity: {},
      initDrawerBoolean: false,
      loadPage(event) {
        let hrefStr = event.target.closest('a').getAttribute('href')
        this.$store.gemstoneStore.setStepValue(2, this.$store.gemstoneStore.stepItem, hrefStr)
      },
      sortBy(sortBy) {
        this.summaryOpen = false
        document.querySelector(selectors.filterFormSortBy).value = sortBy
        this.$refs.filterForm.dispatchEvent(new Event('input'))
      },
      onFormSubmit(evt) {
        var el = evt.target
        const parent = el.closest('li')
        const formEl = el.closest('form')
        const formData = new FormData(formEl)
        const searchParams = new URLSearchParams(formData)
        this.$store.gemstoneStore.setStepValue(
          2,
          this.$store.gemstoneStore.stepItem,
          loadUrl.ring + '&' + searchParams.toString()
        )
      },
      drawerOpen() {
        // remove is-open
        this.$refs.filterForm.querySelectorAll('.is-open').forEach(openItem => {
          $(openItem).trigger('click.collapsible')
          this.filterName = ''
        })
        document.querySelector('html').classList.add('filter-drawer-open')
      },
      drawerClose() {
        document.querySelector('html').classList.remove('filter-drawer-open')
      },

      initDrawer: function () {
        if (!this.initDrawerBoolean && window.innerWidth < 768) {
          this.openFilter = false
          this.initDrawerBoolean = true
          let drawerBtns = this.$refs.filterForm.querySelectorAll('.collection-sidebar button[data-drawer-name]')
          drawerBtns.forEach(el => {
            el.addEventListener('click', event => {
              this.filterName = el.dataset.drawerName
            })
          })
        }
      },
      init() {
        if (this.$store.gemstoneStore.step == 1) {
          navigateWithCartEdit(loadUrl.sapphire)
        }
        window.onload = function () {
          window.StampedFn.loadDisplayWidgets()
        }
        this.filterName = ''
        this.drawerClose()
        theme.collapsibles.init()
        document.querySelectorAll(selectors.filterFormLabel).forEach(label => {
          label.addEventListener('click', event => {
            event.preventDefault()
            var checkboxes = label.querySelectorAll('.tag__input')
            checkboxes.forEach(function (checkbox) {
              checkbox.checked = !checkbox.checked
            })
            this.$refs.filterForm.dispatchEvent(new Event('input'))
          })
        })
        this.$refs.filterForm.addEventListener('input', this.onFormSubmit.bind(this))
        this.$store.gemstoneStore.observer.observe(
          document.querySelector('#CollectionAjaxContent .collection-filter__item--btn.mobile-only svg')
        )

        this.initDrawer()
        window.on('resize', theme.utils.debounce(500, this.initDrawer))
      },
      selectAll() {
        if (this.filterName) {
          const checkboxs = this.$refs.filterForm
            .querySelector('.collection-sidebar button[data-drawer-name="' + this.filterName + '"]')
            .closest('.collection-sidebar__group')
            .querySelectorAll('input[type="checkbox"]:not(:checked)')
          checkboxs.forEach(function (checkbox) {
            checkbox.checked = true
            checkbox.dispatchEvent(new Event('change'))
          })
        }
      },

      clearFilter: function () {
        let drawerBtn = this.$refs.filterForm.querySelector(
          '.collection-sidebar button[data-drawer-name = "' + this.filterName + '"]'
        )
        $(drawerBtn).trigger('click.collapsible')
        this.filterName = ''
      },
      clearFilterTag() {
        this.$store.gemstoneStore.setStepValue(2, this.$store.gemstoneStore.stepItem)
      },

      loadCollection: function () {
        this.$store.gemstoneStore.setStepValue(
          2,
          this.$store.gemstoneStore.stepItem,
          localStorage.getItem('alpine-gemstone-collection-href')
        )
      },
      loadProduct(event) {
        if (!this.$store.gemstoneStore.stepItem.variant_id) {
          alert('Please select a gemstone.')
          return
        }
        const aTarget = event.target.closest('.grid-product__link')
        const hrefStr = aTarget.getAttribute('href')
        const product = JSON.parse(aTarget.dataset.product)
        localStorage.setItem('alpine-gemstone-collection-href', window.location.href)
        const productUrl = new URL(hrefStr, window.location.origin)
        productUrl.searchParams.set('view', 'sapphire')
        productUrl.searchParams.set('local', 'true')
        navigateWithCartEdit(productUrl.pathname + productUrl.search)
      },
    }))
  })
})()

function bookConsultation() {
  const book_header_btn = document.querySelector(".book-appointment-header-btn");
  book_header_btn ? book_header_btn.click() : "";
}
      // bookConsultation: function() {
      //   const book_header_btn = document.querySelector(".book-appointment-header-btn");
      //   book_header_btn?book_header_btn.click():""
      // },
// Adjust mobile filter
 function updateProductMain() {
        const grid = document.getElementById("mobile-product-main__grid");
        const table = document.getElementById("mobile-product-main__table");

        if (window.getComputedStyle(grid).display === "none") {
            return table;
        }
        if (window.getComputedStyle(table).display === "none") {
            return grid;
        }

        return grid;
    }

  const scrollButton = document.getElementById("cust-scroll-button");
  const showFilterButton = document.querySelector(".cust-show__filters:has(#cust-show-filter)");
  const filterSection = document.getElementById("pageGemstonesContainer");

  if (scrollButton && showFilterButton && filterSection) {
  showFilterButton.addEventListener("click", () => {
      filterSection.style.display = "block";
      showFilterButton.style.display = "none";
      scrollButton.style.display = "block";
  });

  window.addEventListener("scroll", () => {
      const productMain = updateProductMain();
      const scrollY = window.scrollY;
      const productTop = productMain.offsetTop;
      const filterTop = filterSection.offsetTop;
      const filterBottom = filterTop + filterSection.offsetHeight;
      const productBottom = productTop + productMain.offsetHeight;

 // scrollY >= productTop - 10
      if (scrollY >= filterBottom) {
          scrollButton.textContent = "Back to Filters";
         // scrollY <= filterTop + 10
      } else if (scrollY <= filterBottom) {
          scrollButton.textContent = "Go to Results";
      }

      if (scrollY > productBottom) {
          scrollButton.style.display = "none";
      } else if(scrollY < productBottom) {
        if (showFilterButton.style.display === "none") {
            scrollButton.style.display = "block";
        }
      }
  });

scrollButton.addEventListener("click", () => {
    const productMain = updateProductMain();
    let targetId = "";

    if (scrollButton.textContent === "Back to Filters") {
        targetId = "pageGemstonesContainer";
    } else {
        targetId = productMain.id;
    }

    history.pushState(null, null, `#${targetId}`);

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        let scrollTop = targetElement.offsetTop;

        if (targetElement.id !== "pageGemstonesContainer") {
            scrollTop -= 70;
        }else{
            scrollTop -= 70;
        }

        window.scrollTo({
            top: scrollTop,
            behavior: "smooth"
        });
    }
});
  }
